import { tituloClinico } from "../../../utils/textoClinico";
import { montoLegible } from "../../../utils/facturaCrear";
import { origenCorto } from "../../../utils/panelAgregar";

/* ============================================================================
   PANEL DE AGREGAR · una fila

   Cuatro columnas, las de la referencia: casilla · procedimiento · origen ·
   precio. El nombre es la única elástica, así que la fila nunca necesita
   scroll lateral dentro de los 566px del panel.

   La etiqueta "En la factura" es la que hace desaparecer la pregunta "¿esto
   ya lo agregué?": la casilla marcada Y la etiqueta dicen lo mismo dos veces,
   a propósito, porque la casilla sola se confunde con "seleccionado".
   ========================================================================== */

function Check({ marcada, peligro }) {
    return (
        <span
            className={`pag__check${marcada ? " is-marcada" : ""}${peligro ? " pag__check--peligro" : ""}`}
            aria-hidden="true"
        >
            {marcada && (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 6L9 17l-5-5" />
                </svg>
            )}
        </span>
    );
}

export default function FilaAgregar({
    item,
    marcada,
    onAlternar,
    // OJO a la diferencia, que no es cosmética:
    //   `marcada`     -> la casilla. En Pendientes significa "está en la
    //                    factura"; en Catálogo, "seleccionado para agregar".
    //   `yaEnFactura` -> la etiqueta. Significa lo mismo en las dos pestañas:
    //                    esto ya está dentro. Es lo que mata la pregunta
    //                    "¿esto ya lo agregué?".
    // En Pendientes coinciden; en Catálogo no, y confundirlas haría que una
    // selección local se leyera como una línea ya facturable.
    yaEnFactura = false,
    ocupada = false,
    // Tercera columna. En Pendientes es el origen (#orden y fecha), que es lo
    // que distingue tres examenes identicos del mismo paciente. En Catalogo no
    // hay orden ni fecha -- son lineas de tarifario -- asi que la pestana pasa
    // otra cosa (el tipo). Si no se pasa nada, se calcula el origen.
    columnaMedia = null,
    // Descartar el pendiente: NO es quitar de la factura. Escribe en la base
    // (estado = "Eliminado") y hace que el procedimiento deje de aparecer como
    // por cobrar para este paciente. Solo la pestaña Pendientes lo pasa; en
    // Catálogo no existe la accion, porque alli la fila es una tarifa, no una
    // prestacion del paciente.
    onDescartar = null,
    // En modo descartar la casilla cambia de significado: ya no es "esta en la
    // factura" sino "elegido para descartar". Se pinta en rojo para que la
    // diferencia se vea, no solo se lea en el aviso de arriba.
    paraDescartar = false,
}) {
    const nombre = tituloClinico(item?.ExamenTipo?.descripcion ?? "");
    const codigo = item?.ExamenTipo?.codigo ?? "";
    const origen = columnaMedia !== null ? columnaMedia : origenCorto(item);
    const precio = item?.precio;

    return (
        <label
            className={`pag__fila${marcada ? " is-marcada" : ""}${
                onDescartar ? " pag__fila--con-descartar" : ""
            }${paraDescartar && marcada ? " is-para-descartar" : ""}`}
        >
            <input
                type="checkbox"
                className="pag__check-input"
                checked={marcada}
                disabled={ocupada}
                onChange={() => onAlternar(item)}
                aria-label={
                    paraDescartar
                        ? `${marcada ? "No descartar" : "Descartar"} ${nombre}`
                        : `${marcada ? "Quitar" : "Agregar"} ${nombre}`
                }
            />
            <Check marcada={marcada} peligro={paraDescartar} />

            <span className="pag__proc">
                <span className="pag__proc-nombre" title={nombre}>
                    {nombre || "—"}
                </span>
                <span className="pag__proc-meta">
                    {codigo && <span className="pag__codigo">{codigo}</span>}
                    {item?.ExamenTipo?.contifico_id && (
                        <span className="pag__tag pag__tag--ok">En Contífico</span>
                    )}
                    {yaEnFactura && (
                        <span className="pag__tag pag__tag--info">En la factura</span>
                    )}
                </span>
            </span>

            <span className="pag__origen" title={origen}>{origen}</span>
            <span className="pag__precio">${montoLegible(precio)}</span>

            {onDescartar && (
                <button
                    type="button"
                    className="pag__descartar"
                    title="Ya no se va a hacer: quitarlo de los pendientes"
                    aria-label={`Descartar ${nombre} de los pendientes`}
                    onClick={(e) => {
                        // La fila entera es un <label>: sin esto, pulsar la
                        // papelera ademas marcaria la casilla.
                        e.preventDefault();
                        e.stopPropagation();
                        onDescartar(item);
                    }}
                >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
                        <path d="M3 6h18" /><path d="M8 6V4h8v2" />
                        <path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6" /><path d="M14 11v6" />
                    </svg>
                </button>
            )}
        </label>
    );
}
